import {cleanObject} from '~/default/scripts/utils/generic'

const apiRequest = async (endpoint, queryParams = {}, options = {}) => {
  // Initial checks
  if (!endpoint || !endpoint.startsWith('/') || !endpoint.endsWith('/')) {
    throw 'Error: endpoint is required. Must start and end with "/"'
  }

  // Build up variables
  const params = new URLSearchParams(cleanObject(queryParams)).toString()
  const fetchUrl = `https://api.webcloud.it/v3${endpoint}${params !== '' ? '?' : ''}${params}`
  const fetchOptions =
    Object.keys(options).length > 0
      ? options
      : {
          method: 'GET',
          headers: {
            'X-Ads-Context': 'Asiago.it',
            'Content-Type': 'application/json',
          },
        }

  // Let's go!
  try {
    const res = await fetch(fetchUrl, fetchOptions)

    if (!res.ok) {
      const error = new Error(res.statusText)
      error.json = res.json()
      throw error
    }

    const json = await res.json()

    return {
      success: true,
      data: json,
    }
  } catch (error) {
    if (error.json) {
      error.json.then(x => {
        error.message = x.message
      })
    }

    return {
      success: false,
      error: error,
    }
  }
}

export const getProperties = async queryParams => {
  // This param is required since the request has no Authorization header
  queryParams['Results.Format'] = 'Essentials'

  const req = await apiRequest('/realestate/properties/', queryParams)
  return req
}

export const getPropertiesDetails = async queryParams => {
  const req = await apiRequest('/realestate/properties/details/', queryParams, {
    headers: {
      'Content-type': 'application/json',
    },
  })
  return req
}
